import { Archive, Lightning, Buildings, User } from "@phosphor-icons/react";

export const ADMIN_EMAIL = "sam@ldbsemail.com";

export const PROVIDERS = [
  { id: "openrouter", name: "OpenRouter", prefix: "sk-or-", description: "MiMo-V2-Pro, Sonnet 4.6, DeepSeek V3.2, GPT-5.4, Gemini 3.1 + more" },
];

export const BASE_TABS = [
  { id: "personalization", label: "Brand Voice" },
  { id: "defaults", label: "Defaults" },
  { id: "resources", label: "Resource Bank" },
  { id: "billing", label: "Billing" },
  { id: "apikeys", label: "API Keys" },
  { id: "workspace", label: "Workspace" },
  { id: "trash", label: "Trash" },
];

export const TONE_OPTIONS = [
  "Direct", "Sharp", "Calm", "Contrarian", "Insightful", "Practical", "Urgent",
  "Warm", "Provocative", "Technical", "Empathetic", "Witty", "Authoritative", "Conversational",
];

export const AI_MODELS = [
  { value: "OpenRouter: MiMo-V2-Pro", label: "MiMo-V2-Pro (Xiaomi)" },
  { value: "OpenRouter: Claude Sonnet 4.6", label: "Claude Sonnet 4.6 (Anthropic)" },
  { value: "OpenRouter: DeepSeek V3.2", label: "DeepSeek V3.2 (DeepSeek)" },
  { value: "OpenRouter: MiniMax M2.7", label: "MiniMax M2.7 (MiniMax)" },
  { value: "OpenRouter: Qwen 3.6 Plus", label: "Qwen 3.6 Plus (Alibaba)" },
  { value: "OpenRouter: Claude Opus 4.6", label: "Claude Opus 4.6 (Anthropic)" },
  { value: "OpenRouter: GPT-5.4", label: "GPT-5.4 (OpenAI)" },
  { value: "OpenRouter: Gemini 3.1 Pro", label: "Gemini 3.1 Pro (Google)" },
  { value: "OpenRouter: Step 3.5 Flash", label: "Step 3.5 Flash (StepFun)" },
  { value: "OpenRouter: GLM 5 Turbo", label: "GLM 5 Turbo (Z.ai)" },
  { value: "OpenRouter Auto", label: "Auto (Best Available)" },
];

export function FieldLabel({ label, sub }) {
  return (
    <div className="mb-1.5">
      <label className="block text-sm font-medium text-[var(--text-secondary)]">{label}</label>
      {sub && <p className="text-xs text-[var(--text-muted)] mt-0.5">{sub}</p>}
    </div>
  );
}

export function ProfileInput({ label, sub, value, onChange, placeholder, textarea }) {
  const cls = "w-full bg-[var(--bg-base)] border border-[var(--border-strong)] rounded-lg px-3 py-2 text-sm text-[var(--text-primary)] placeholder:text-[var(--text-muted)] focus:outline-none focus:ring-1 focus:ring-[#FF4400] transition-colors";
  return (
    <div>
      <FieldLabel label={label} sub={sub} />
      {textarea ? (
        <textarea className={cls + " min-h-[90px] resize-y"} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} />
      ) : (
        <input className={cls} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} />
      )}
    </div>
  );
}

export function UsageMeter({ label, used, limit, suffix = "", icon: Icon, testId }) {
  const unlimited = limit === null || limit === undefined;
  const pct = unlimited ? 0 : Math.min((used / limit) * 100, 100);
  const ratio = unlimited ? 0 : used / limit;
  const barColor = ratio >= 1 ? "#EF4444" : ratio >= 0.8 ? "#F59E0B" : "#FF4400";

  return (
    <div data-testid={testId}>
      <div className="flex items-center justify-between mb-1.5">
        <div className="flex items-center gap-2">
          {Icon && <Icon size={14} className="text-[var(--text-muted)]" />}
          <span className="text-sm text-[var(--text-secondary)]">{label}</span>
        </div>
        <span className="text-xs font-['JetBrains_Mono'] text-[var(--text-muted)]">
          {used.toLocaleString()} / {unlimited ? "Unlimited" : limit.toLocaleString()}{suffix}
        </span>
      </div>
      {!unlimited && (
        <div className="h-2 rounded-full bg-[var(--bg-base)] overflow-hidden">
          <div className="h-full rounded-full transition-all" style={{ width: `${pct}%`, backgroundColor: barColor }} />
        </div>
      )}
    </div>
  );
}
